// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListItem-module__wrapper___OKdVw {
  display: flex;
  align-items: center;
  gap: 30px;
}

.ListItem-module__circle___aKavq {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  height: 88px;
  font: var(--font-h2);
  color: var(--color-surface);
  border-radius: 100px;
  background: var(--color-primary);
}

.ListItem-module__title___TdjVB {
  font: var(--font-h3);
  color: var(--color-black);
  white-space: pre-wrap;
}

.ListItem-module__text___tpzgw {
  font: var(--font-main);
  color: var(--color-black);
  margin-top: 16px;
  white-space: pre-wrap;
}

.ListItem-module__exile___MCW5l {
  font: var(--font-h3);
  color: var(--color-secondary);
  white-space: pre-wrap;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ListItem-module__exile___MCW5l:hover,
.ListItem-module__exile___MCW5l:active,
.ListItem-module__exile___MCW5l:focus {
  color: var(--color-black);
}

@media (min-width: 768px) and (max-width: 1199px) {

  .ListItem-module__circle___aKavq {
    width: 61px;
    height: 61px;
    padding: 14px 15px;
  }

  .ListItem-module__title___TdjVB {
    line-height: normal;
    letter-spacing: -0.5px;
  }

  .ListItem-module__text___tpzgw {
    margin-top: 4px;
    white-space: normal;
  }

  .ListItem-module__exile___MCW5l {
    line-height: normal;
    letter-spacing: -0.5px;
  }

}

@media (min-width: 360px) and (max-width: 767px) {

  .ListItem-module__wrapper___OKdVw {
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }

  .ListItem-module__circle___aKavq {
    width: 42px;
    height: 42px;
    padding: 9.744px 10.44px;
  }

  .ListItem-module__title___TdjVB {
    line-height: normal;
    letter-spacing: -0.5px;
    white-space: normal;
    white-space: initial;
  }

  .ListItem-module__text___tpzgw {
    margin-top: 4px;
    white-space: normal;
  }

  .ListItem-module__exile___MCW5l {
    line-height: normal;
    letter-spacing: -0.5px;
    white-space: normal;
    white-space: initial;
  }

}`, "",{"version":3,"sources":["webpack://./src/entities/listItem/ui/ListItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;AAEF;;AAEA;;EAEE;IACE,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,mBAAoB;IAApB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,mBAAoB;IAApB,oBAAoB;EACtB;;AAEF","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.circle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 88px;\n  height: 88px;\n  font: var(--font-h2);\n  color: var(--color-surface);\n  border-radius: 100px;\n  background: var(--color-primary);\n}\n\n.title {\n  font: var(--font-h3);\n  color: var(--color-black);\n  white-space: pre-wrap;\n}\n\n.text {\n  font: var(--font-main);\n  color: var(--color-black);\n  margin-top: 16px;\n  white-space: pre-wrap;\n}\n\n.exile {\n  font: var(--font-h3);\n  color: var(--color-secondary);\n  white-space: pre-wrap;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.exile:hover,\n.exile:active,\n.exile:focus {\n  color: var(--color-black);\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n\n  .circle {\n    width: 61px;\n    height: 61px;\n    padding: 14px 15px;\n  }\n\n  .title {\n    line-height: normal;\n    letter-spacing: -0.5px;\n  }\n\n  .text {\n    margin-top: 4px;\n    white-space: normal;\n  }\n\n  .exile {\n    line-height: normal;\n    letter-spacing: -0.5px;\n  }\n\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n\n  .wrapper {\n    align-items: flex-start;\n    gap: 16px;\n    align-self: stretch;\n  }\n\n  .circle {\n    width: 42px;\n    height: 42px;\n    padding: 9.744px 10.44px;\n  }\n\n  .title {\n    line-height: normal;\n    letter-spacing: -0.5px;\n    white-space: initial;\n  }\n\n  .text {\n    margin-top: 4px;\n    white-space: normal;\n  }\n\n  .exile {\n    line-height: normal;\n    letter-spacing: -0.5px;\n    white-space: initial;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ListItem-module__wrapper___OKdVw`,
	"circle": `ListItem-module__circle___aKavq`,
	"title": `ListItem-module__title___TdjVB`,
	"text": `ListItem-module__text___tpzgw`,
	"exile": `ListItem-module__exile___MCW5l`
};
export default ___CSS_LOADER_EXPORT___;
